import angular from 'angular';

export const AUTH_EVENTS = {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
};

export const ERROR_EVENTS = {
    serverError: 'server-error',
    notFound: 'not-found',
    frontTimeout: 'front-timeout',
};

export const EMPLOYER_REP_AUTH_FLOW = {
    DIVERSITY: 'DIVERSITY',
    FEEDBACK: 'FEEDBACK',
    SUBMIT_TO_EMPLOYER: 'SUBMIT_TO_EMPLOYER',
    COMPLETE_JOB_DEFINITION_UPLOAD_JOB_WIZARD: 'COMPLETE_JOB_DEFINITION_UPLOAD_JOB_WIZARD',
};

export const AUTH0_CONSTS = {
    domain: 'talenya.eu.auth0.com',
    clientId: 'tnZd7b5I3Ho1FmEMvMwktyVA0AqBkt3f',
};

export const FE_VERSION = {
    version: '0.4b',
};

export const DOMAIN_CONFIG = {
    MIN_SUCCESS_GRADE: 0.5,
    DATA_ANALYST_EMAIL: 'data_analyst@talenya.com',
    SHOW_LIST_ITEMS: 8,
};

export const NOTIFICATION_CONSTS = {
    TYPE: {
        INFO: 'info',
        SUCCESS: 'success',
        WARNING: 'warning',
        ERROR: 'error',
    },
    DEFAULT_DURATION: 3500,
    DEFAULT_ANIMATION_DURATION: 565,
};

export const CACHE_CONSTS = {
    CACACHE_MAX_AGE_MS: 120000
};

angular
    .module('TALENYA-FE')
    .constant('AUTH_EVENTS', AUTH_EVENTS)
    .constant('ERROR_EVENTS', ERROR_EVENTS)
    .constant('AUTH0_CONSTS', AUTH0_CONSTS)
    .constant('FE_VERSION', FE_VERSION)
    .constant('DOMAIN_CONFIG', DOMAIN_CONFIG)
    .constant('EMPLOYER_REP_AUTH_FLOW', EMPLOYER_REP_AUTH_FLOW)
    .constant('NOTIFICATION_CONSTS', NOTIFICATION_CONSTS)
    .constant('CACHE_CONSTS', CACHE_CONSTS);
